import _groupBy from 'lodash/groupBy'
import { TRACKING } from 'domains/account-management/utils/constants/AccountManagement.constants'
import { trackEvent } from 'utils/events/trackEvent'
import { type FormData } from 'domains/account-management/components/account-form/utils/AccountForm.types'
import { OptionType } from 'domains/account-management/components/retailer-location-store-group-select/utils/types'

const numberStoreGroups = (formData: FormData): number => {
  const { retailerLocationsStoreGroups } = formData

  const groupedRetailerLocationsStoreGroups = _groupBy(retailerLocationsStoreGroups, 'type')
  const storeGroupOptions = groupedRetailerLocationsStoreGroups[OptionType.StoreGroup] ?? []
  return storeGroupOptions.length
}

interface trackAccountCreatedProps {
  formData: FormData
}

export const trackAccountCreated = ({ formData }: trackAccountCreatedProps) => {
  trackEvent({
    id: TRACKING.create.id,
    description: TRACKING.create.description,
    data: {
      numStoreGroups: numberStoreGroups(formData),
    },
  })
}

interface trackAccountUpdatedProps {
  formData: FormData
}

export const trackAccountUpdated = ({ formData }: trackAccountUpdatedProps) => {
  trackEvent({
    id: TRACKING.update.id,
    description: TRACKING.update.description,
    data: {
      numStoreGroups: numberStoreGroups(formData),
    },
  })
}
